import { render, staticRenderFns } from "./MtqrList.vue?vue&type=template&id=2474119b&scoped=true&"
import script from "./MtqrList.vue?vue&type=script&lang=js&"
export * from "./MtqrList.vue?vue&type=script&lang=js&"
import style0 from "./MtqrList.vue?vue&type=style&index=0&id=2474119b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2474119b",
  null
  
)

export default component.exports